import { formatDate } from '@utils/timeFormatter';
import { useTranslation } from 'react-i18next';
import { Certification } from '../../../../../../../types/psychometric';

interface CertificationItemProps {
  certification: Certification;
}

export default function CertificationItem({
  certification,
}: CertificationItemProps) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-4 pb-8 border-b border-white-200 last:border-0">
      <img
        src={`https://logo.clearbit.com/${certification.issuingOrganization
          .toLowerCase()
          .replace(/[^a-zA-Z0-9]/g, '')}.com`}
        alt={certification.issuingOrganization}
        className="w-12 h-12 rounded object-contain bg-white-50"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
            certification.issuingOrganization,
          )}&background=random`;
        }}
      />

      <div className="flex-1">
        <h3 className="text-lg font-semibold text-white-900">
          {certification.name}
        </h3>
        <p className="text-base text-white-700">
          {certification.issuingOrganization}
        </p>
        <p className="text-sm text-white-500">
          {t('profile.issued', { date: formatDate(certification.issueDate * 1000) })}
        </p>
      </div>
    </div>
  );
}
